const theme = {
    light: 'Light',
    dark: 'Dark',
    toggleTheme: 'Toggle theme',
  } as const;

export default theme;
